// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"71cd502149a9a3793974","339":"f56267020d1df1980a84"}[chunkId] + ".js";
};